import { render, staticRenderFns } from "./SinglePkg.vue?vue&type=template&id=d2020772&scoped=true&"
import script from "./SinglePkg.vue?vue&type=script&lang=js&"
export * from "./SinglePkg.vue?vue&type=script&lang=js&"
import style0 from "./SinglePkg.vue?vue&type=style&index=0&id=d2020772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2020772",
  null
  
)

export default component.exports